import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
} from "react-native";
import React, { useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import styles from "../../../styles/styles";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../../../globalStyles/globalStyles";

const CircleDesign = () => {
  return (
    <View style={[styles.optionCircle, styles.optionOnSelect]}>
      <View style={styles.optionCircleInner}></View>
    </View>
  );
};

export default function EditGender({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { staticData, setStaticData } = route.params;

  const [gender, setGender] = useState(staticData.gender);
  const [toggleCheckBox, setToggleCheckBox] = useState(false);
  useEffect(() => {
    setStaticData((prev: any) => {
      return {
        ...prev,
        gender:gender
    }});
    // dispatch(setGenderHook(gender));
  }, [gender]);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex",
        alignItems: "center", height: "100%",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, {}]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              {/* <Image source={Icons.Back} /> */}
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Gender</Text>
          </View>
        </View>
      </View>
      <View style={{ backgroundColor: "white", width: "90%", height: "90%" }}>
        <View>
          <View style={styles.middleScreen}>
            {/* <Text style={styles.selectGender}>Which gender best discribe you?</Text> */}
            <View style={styles.optionBox}>
              <TouchableOpacity
                onPress={() => {
                  setGender("Male");
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>Male</Text>
                  {gender == "Male" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  setGender("Female");
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>Female</Text>
                  {gender == "Female" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  setGender("Other");
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>Other</Text>
                  {gender == "Other" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>
            </View>
            {/* <View style={styles.innerBottom}>
              <CheckBox
                //   tintColors={{ true: "rgba(192, 164, 111, 1)" }}
                disabled={false}
                value={toggleCheckBox}
                onValueChange={(newValue) => setToggleCheckBox(newValue)}
                style={styles.checkBox}
                // onCheckColor="rgba(192, 164, 111, 1)"
              />
              <Text>Visible on Profile</Text>
            </View> */}
          </View>
          {/* {question=="likeToDate" && <SelectLikeToDate />} */}
        </View>

        <View style={{ height: 100 }}></View>
      </View>
    </SafeAreaView>
  );
}
